import React from 'react';
import MarketTierIcon from 'core/assets/svg/market-tier-logo.svg?react';
import InfoIcon from 'core/assets/svg/ic-info-white.svg?react';
import { Tooltip } from 'core/components/tooltip';
import { Label } from 'core/components/label';
import cls from 'classnames';

import useStyles from './market-tier-rating.styles';

const tooltipText =
  'Each member or potential member’s account is rated to show how well it fits our target market. The better the fit, the more logos you get. We’re especially looking for members with bundled policies, full auto coverage, and previous insurance.';

const NoTierCaption = ({ classes }) => {
  const text =
    'There is no target market tier assigned to this offer since there is not an eligible policy type on this offer.';
  return (
    <div className={classes.noRatingSection}>
      <InfoIcon width={32} height={32} />
      <span className={classes.noMarketTierText}>{text}</span>
    </div>
  );
};

const MarketTierRating = ({ marketTier = 0, mode = 'dark' }) => {
  const classes = useStyles({ mode });

  return (
    <div className={classes.content}>
      <div className={classes.section}>
        <Label type="policyLabel" className={classes.label}>
          TARGET MARKET TIER
        </Label>
        <Tooltip className={classes.tooltip} text={tooltipText} smallIcon />
      </div>
      {marketTier > 0 ? (
        <div className={classes.ratingRow}>
          {[1, 2, 3, 4, 5].map((i) => (
            <MarketTierIcon
              key={i}
              className={cls(classes.marketTierIcon, {
                [classes.iconActive]: marketTier >= i
              })}
            />
          ))}
        </div>
      ) : (
        <NoTierCaption classes={classes} />
      )}
    </div>
  );
};

export default MarketTierRating;
